import React from 'react'
import GitHubIcon from '@mui/icons-material/GitHub';

const Footer = () => {
  return (
<div className='flex justify-center items-center gap-2'>
<div className='text-center'>2022 Zendo, Create and design by Noxplit</div>

<a href='https://github.com/Noxplit'><GitHubIcon /></a>
</div>
  )
}

export default Footer